import { render, staticRenderFns } from "./RadioSelect.vue?vue&type=template&id=22558f61&"
import script from "./RadioSelect.vue?vue&type=script&lang=js&"
export * from "./RadioSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports